import { ResponsesListItem } from '../types';
import { getResponsesListItemCreatedAt } from './getResponsesListItemCreatedAt';

export function sortResponsesListItemsByCreationDate(
  responsesListItems: ResponsesListItem[]
) {
  return responsesListItems.sort((itemA, itemB) => {
    const dateA = getResponsesListItemCreatedAt(itemA);
    const dateB = getResponsesListItemCreatedAt(itemB);

    return dateB.getTime() - dateA.getTime();
  });
}
